import {
  Dialog,
  DialogActions as MaterialDialogActions,
  DialogContent as MaterialDialogContent,
  DialogTitle as MaterialDialogTitle,
} from '@material-ui/core';
import {Button} from '@wandb/weave/components/Button';
import React, {useState} from 'react';
import styled from 'styled-components';

const DialogContent = styled(MaterialDialogContent)`
  padding: 0 32px !important;
`;
DialogContent.displayName = 'S.DialogContent';

const DialogTitle = styled(MaterialDialogTitle)`
  padding: 32px 32px 16px 32px !important;

  h2 {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
  }
`;
DialogTitle.displayName = 'S.DialogTitle';

const DialogActions = styled(MaterialDialogActions)<{$align: string}>`
  justify-content: ${({$align}) =>
    $align === 'left' ? 'flex-start' : 'flex-end'} !important;
  padding: 32px 32px 32px 32px !important;
`;
DialogActions.displayName = 'S.DialogActions';

type ConfirmDeleteDialogProps = {
  setConfirmDelete: (confirmDelete: boolean) => void;
  onDeleteCallback: () => void;
};

export const ConfirmDeleteDialog = ({
  setConfirmDelete,
  onDeleteCallback,
}: ConfirmDeleteDialogProps) => {
  const [deleteLoading, setDeleteLoading] = useState(false);

  const onDelete = () => {
    setDeleteLoading(true);
    onDeleteCallback();
    setDeleteLoading(false);
    setConfirmDelete(false);
  };

  return (
    <Dialog
      open={true}
      onClose={() => {
        setConfirmDelete(false);
      }}
      maxWidth="xs"
      fullWidth>
      <DialogTitle>Delete this comparison?</DialogTitle>
      <DialogContent style={{overflow: 'hidden'}}>
        <p>
          You can delete this comparison if you believe it is no longer useful
          to you and your team. This cannot be undone.
        </p>
      </DialogContent>
      <DialogActions $align="left">
        <Button
          variant="destructive"
          disabled={deleteLoading}
          onClick={onDelete}>
          Delete comparison
        </Button>
        <Button
          variant="ghost"
          disabled={deleteLoading}
          onClick={() => {
            setConfirmDelete(false);
          }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
